module.exports = __webpack_public_path__ + "img/relevant.343d4fc4.svg";